export interface WaveItem {
  nextIndex: number;
  value: number;
}

export class SkeletonTools {
  public static readonly intervalMs = 80;
  public static readonly wave = this.createWave(0.75, -0.05, 0.3, 0.05);

  public static bumpWaveIndex(waveIndex: number): number {
    return (waveIndex + 1) % this.wave.length;
  }

  public static nextWaveItem(waveIndex: number): WaveItem {
    return {
      nextIndex: this.bumpWaveIndex(waveIndex),
      value: this.wave[waveIndex],
    };
  }

  /**
   * Creates a wave pattern array starting from "start", changing the value by "step",
   * reaching up to "end", and then changing back to start by "stepBack".
   */
  private static createWave(start: number, step: number, end: number, stepBack: number): number[] {
    const wave: number[] = [];
    let current = start;
    const upFirst: boolean = start < end;

    while ((upFirst && current <= end) || (!upFirst && current >= end)) {
      wave.push(current);
      current += step;
    }

    current = end;
    while ((upFirst && current >= start) || (!upFirst && current <= start)) {
      wave.push(current);
      current += stepBack;
    }
    return wave;
  }
}
